import { ClientFlavor, ClientType } from "@ms/uno-constants/lib/local/AppConstants";
import { LicenseTier } from "@ms/uno-constants/lib/local/LicenseConstants";
import { CoreTelemetryLicenseType, CoreTelemetrySubWorkload, CoreTelemetryWorkload } from "../loggers/ICoreTelemetryLogger";
/**
 * Maps host metadata to the bounded workload dimensions emitted by Core Telemetry.
 *
 * @param clientType The host client type.
 * @param clientFlavor The experience within the host, when available.
 * @returns The approved workload and subworkload pair, or `Other` values for an unrecognized host.
 */ export function getCoreTelemetryWorkload(clientType, clientFlavor) {
    switch(clientType){
        case ClientType.Web:
            return {
                workload: CoreTelemetryWorkload.PlannerWeb,
                subWorkload: CoreTelemetrySubWorkload.Planner
            };
        case ClientType.Teams:
            if (clientFlavor === ClientFlavor.Tab || clientFlavor === ClientFlavor.ConfigTab || clientFlavor === ClientFlavor.RemoveTab) {
                return {
                    workload: CoreTelemetryWorkload.Teams,
                    subWorkload: CoreTelemetrySubWorkload.ChannelsTab
                };
            }
            if (clientFlavor === ClientFlavor.TaskFromMessage) {
                return {
                    workload: CoreTelemetryWorkload.Teams,
                    subWorkload: CoreTelemetrySubWorkload.TaskFromMessage
                };
            }
            return {
                workload: CoreTelemetryWorkload.Teams,
                subWorkload: CoreTelemetrySubWorkload.Planner
            };
        case ClientType.Outlook:
            return {
                workload: CoreTelemetryWorkload.Outlook,
                subWorkload: CoreTelemetrySubWorkload.Planner
            };
        case ClientType.Office:
            return {
                workload: CoreTelemetryWorkload.Other,
                subWorkload: CoreTelemetrySubWorkload.Planner
            };
        case ClientType.Sharepoint:
            return {
                workload: CoreTelemetryWorkload.SharePoint,
                subWorkload: CoreTelemetrySubWorkload.SharePointPlannerWebPart
            };
        case ClientType.Loop:
            return {
                workload: CoreTelemetryWorkload.Loop,
                subWorkload: CoreTelemetrySubWorkload.TaskListComponent
            };
        default:
            return {
                workload: CoreTelemetryWorkload.Other,
                subWorkload: CoreTelemetrySubWorkload.Other
            };
    }
}
export function getCoreTelemetryLicenseType(licenseTier) {
    switch(licenseTier){
        case LicenseTier.None:
            return CoreTelemetryLicenseType.None;
        case LicenseTier.ReadOnlyPremium:
            return CoreTelemetryLicenseType.ReadOnlyPremium;
        case LicenseTier.P1:
            return CoreTelemetryLicenseType.P1;
        case LicenseTier.P3:
            return CoreTelemetryLicenseType.P3;
        case LicenseTier.P5:
            return CoreTelemetryLicenseType.P5;
        default:
            const unsupportedLicenseTier = licenseTier;
            throw new Error(`Unsupported Core Telemetry license tier: ${unsupportedLicenseTier}`);
    }
}
